import { ValueSaveRequestDto } from '../dto/request/value-save-request.dto';
import { ValueUpdateRequestDto } from '../dto/request/value-update-request.dto';
import { ValueResponseDto } from '../dto/response/value-response.dto';
import { BaseLandscapeService } from '../../base-landscape.service';

class TargetService extends BaseLandscapeService {
  public async fetchTargetById(id: string): Promise<ValueResponseDto> {
    const response = await this.get<ValueResponseDto>(`/target/${id}`);
    return response.data;
  }

  public async saveTarget(
    saveRequest: ValueSaveRequestDto
  ): Promise<ValueResponseDto> {
    const response = await this.post<ValueResponseDto>(`/target`, saveRequest);
    return response.data;
  }

  public async updateTarget(
    updateRequest: ValueUpdateRequestDto
  ): Promise<ValueResponseDto> {
    const response = await this.put<ValueResponseDto>(`/target`, updateRequest);
    return response.data;
  }

  public async updateVerificationLabel(
    updateRequest: ValueUpdateRequestDto
  ): Promise<ValueResponseDto> {
    const response = await this.put<ValueResponseDto>(
      `/target/putverificationlabel`,
      updateRequest
    );
    return response.data;
  }

  public async deleteTarget(existingId: string): Promise<void> {
    await this.delete<void>(`/target/${existingId}`);
  }
}

const targetService = new TargetService();
export default targetService;
